// src/admin/AdminLogin.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminAuthAPI } from '../services/api';
import AuthLeftPanel from '../pages/auth/AuthLeftPanel';
import '../pages/auth/AuthPages.css';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail]           = useState('');
  const [password, setPassword]     = useState('');
  const [error, setError]           = useState('');
  const [loading, setLoading]       = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const response = await adminAuthAPI.login(email, password);
      localStorage.setItem('admin_token', response.token);
      localStorage.setItem('admin_user', JSON.stringify(response.user));
      localStorage.setItem('admin_login_time', Date.now().toString());
      navigate('/admin/users');
    } catch (err) {
      setError(err.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <AuthLeftPanel adminMode={true} />

      <div className="auth-right">
        <div className="auth-right-inner">

          <div className="auth-right-header">
            <h1 className="auth-right-title">Admin Sign In</h1>
            <p className="auth-right-subtitle">Access the admin control panel with your credentials.</p>
          </div>

          {error && (
            <div className="auth-alert auth-alert-error">
              <i className="bi bi-exclamation-triangle-fill"></i>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="auth-field">
              <label className="auth-field-label">
                <i className="bi bi-envelope-fill" style={{ marginRight: 6, color: '#00A19D' }}></i>
                Email Address
              </label>
              <div className="auth-input-wrap">
                <input
                  type="email"
                  className="auth-input"
                  placeholder="admin@example.com"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setError(''); }}
                  required
                  disabled={loading}
                  autoComplete="email"
                  autoFocus
                />
              </div>
            </div>

            <div className="auth-field">
              <label className="auth-field-label">
                <i className="bi bi-lock-fill" style={{ marginRight: 6, color: '#00A19D' }}></i>
                Password
              </label>
              <div className="auth-input-wrap">
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="auth-input has-icon-right"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => { setPassword(e.target.value); setError(''); }}
                  required
                  disabled={loading}
                  autoComplete="current-password"
                />
                <button type="button" className="auth-input-eye" onClick={() => setShowPassword(!showPassword)}>
                  <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                </button>
              </div>
            </div>

            <button type="submit" className="auth-submit-btn" disabled={loading}>
              {loading
                ? <><span className="auth-spinner"></span> Signing in...</>
                : <><i className="bi bi-shield-lock-fill"></i><span>Sign In as Admin</span></>
              }
            </button>
          </form>

          <div className="auth-divider"><span>or</span></div>

          <a href="/login" className="auth-secondary-btn">
            <i className="bi bi-person-fill"></i>
            User Login
          </a>

          <div className="auth-right-footer">
            © 2026 Vastu Analyzer · Admin Portal
          </div>

        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
